import { QuoteDestinationsResponse } from 'freely-shared-types';

import { openApiInstances } from './openApis';

export const getQuoteDestinations = () => {
  return openApiInstances.Quote.get<QuoteDestinationsResponse>('/destinations');
};
